module.exports = __webpack_public_path__ + "img/home_logo2.fec5c34.png";